<template>
  <v-layout row justify-center>
    <v-dialog v-if="!loading" v-model="dialog" hide-overlay max-width="600px">
      <v-card v-if="billing && billing_debug">
        <v-toolbar color="teal" dark>
          <v-toolbar-side-icon></v-toolbar-side-icon>

          <v-toolbar-title
            >Fatura -
            {{
              billing.consumer_unit + " :: " + billing.competence
            }}</v-toolbar-title
          >

          <v-spacer></v-spacer>

          <v-btn icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- billing_debug: {{billing_debug}}
		billing_debug_error: {{billing_debug_error}} -->
        <v-list>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Erro</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile v-for="(subItem, i) in billing_debug_error" :key="i">
              <v-list-tile-content>
                <v-list-tile-subtitle
                  >{{ subItem.text }}: {{ subItem.value }}</v-list-tile-subtitle
                >
              </v-list-tile-content>

              <!-- <v-list-tile-action>
					<v-icon>{{ subItem.action }}</v-icon>
				</v-list-tile-action> -->
            </v-list-tile>
          </v-list-group>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>Transação</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile
              v-for="(subItem, i) in billing_debug_transaction_sent"
              :key="i"
            >
              <v-list-tile-content>
                <v-list-tile-subtitle
                  >{{ subItem.text }}: {{ subItem.value }}</v-list-tile-subtitle
                >
              </v-list-tile-content>

              <!-- <v-list-tile-action>
					<v-icon>{{ subItem.action }}</v-icon>
				</v-list-tile-action> -->
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-card>
      <v-card v-else>
        <v-card-title>Erro: </v-card-title>
        {{ error }}
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" hide-overlay persistent width="300" v-else>
      <v-card color="red" dark>
        <v-card-text>
          Buscando debug da fatura
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { eventBus } from "../../main";
import { getBillingDebug } from "../../services/billing";
export default {
  data() {
    return {
      loading: true,
      billing: null,
      billing_debug: null,
      error: null,
      dialog: false,
    };
  },
  mounted() {
    eventBus.$on("billingDebug", (billing) => {
      console.log("billing: ", billing);
      this.dialog = true;
      this.billing = billing;
      this.loading = true;
      getBillingDebug(billing.id)
        .then((doc) => {
          if (doc.exists) {
            this.billing_debug = {
              id: doc.id,
              ...doc.data(),
            };
            console.log("billing_debug: ", this.billing_debug);
            this.loading = false;
          } else {
            this.error = "Não existe debug para essa fatura.";
            this.loading = false;
          }
        })
        .catch((error) => {
          console.error("Erro ao pegar o debug da fatura. ", error);
          this.error = "Erro ao pegar o debug da fatura.";
          this.loading = false;
        });
    });
  },
  computed: {
    billing_debug_error() {
      if (!this.billing_debug) return null;
      // console.log(JSON.stringify(JSON.parse(this.billing_debug.error), null, 2))
      // console.log('error', JSON.parse(this.billing_debug.error))
      // console.log('error isArray: ', this.billing_debug.error)
      let array = JSON.parse(this.billing_debug.error)[0];
      // console.log('array: ', array)
      // console.log('keys: ', Object.keys(array))
      let error_list = Object.keys(array).map((i) => {
        // console.log('i: ', array[i])
        return {
          text: i,
          value: array[i],
        };
      });
      // let error_parse = JSON.parse(this.billing_debug.error[0])
      // let error_list = {
      // 	type: error_parse.type,
      // 	parameter_name: error_parse.parameter_name,
      // 	message: error_parse.message,
      // }
      // console.log("error_list: ", error_list)
      return error_list;
    },
    billing_debug_transaction_sent() {
      if (!this.billing_debug) return null;
      // return JSON.parse(this.billing_debug.error)
      // console.log('error isArray: ', this.billing_debug.error)
      // return  JSON.parse(this.billing_debug.error)
      let array = JSON.parse(this.billing_debug.transaction_sent);
      // console.log('array: ', array)
      // console.log('keys: ', Object.keys(array))
      let error_list = Object.keys(array).map((i) => {
        // console.log('i: ', array[i])
        return {
          text: i,
          value: array[i],
        };
      });
      // let error_parse = JSON.parse(this.billing_debug.error[0])
      // let error_list = {
      // 	type: error_parse.type,
      // 	parameter_name: error_parse.parameter_name,
      // 	message: error_parse.message,
      // }
      console.log("error_list: ", error_list);
      return error_list;
    },
  },
};
</script>
